import type { Client } from 'graphql-ws'
import { MessageType, stringifyMessage } from 'graphql-ws'

const PING_INTERVAL_MS = 25_000

export function startConnectionHealthCheck(
  client: Client,
  socket: WebSocket,
): () => void {
  let awaitingServerMessage = false
  let lastHeartbeatAt = performance.now()

  // graphql-ws waits for a pong before scheduling its next ping.
  const heartbeat = () => {
    const now = performance.now()
    const offline = window.navigator.onLine === false
    const wasSuspended = now - lastHeartbeatAt > PING_INTERVAL_MS * 2
    lastHeartbeatAt = now
    if (offline || document.visibilityState === 'hidden' || wasSuspended) {
      awaitingServerMessage = false
    }
    if (offline || socket.readyState !== WebSocket.OPEN) {
      return
    }
    if (awaitingServerMessage) {
      client.terminate()
      return
    }
    awaitingServerMessage = true
    socket.send(stringifyMessage({ type: MessageType.Ping }))
  }

  const resetHeartbeat = () => {
    awaitingServerMessage = false
    lastHeartbeatAt = performance.now()
  }

  const removeMessageListener = client.on('message', () => {
    awaitingServerMessage = false
  })
  document.addEventListener('visibilitychange', resetHeartbeat)
  window.addEventListener('offline', resetHeartbeat)
  const timer = setInterval(heartbeat, PING_INTERVAL_MS)

  return () => {
    clearInterval(timer)
    document.removeEventListener('visibilitychange', resetHeartbeat)
    window.removeEventListener('offline', resetHeartbeat)
    removeMessageListener()
  }
}
